import React, { useEffect } from "react";
import styles from "./Login.module.css";
import checkIcon from "@/assets/images/check.png";
import { useAtom } from "jotai";
import { loginState } from "../state.js";
import { useConfirm, Footer } from "@components";
import Axios from "@/Axios.js";
import { setCookie, removeCookie } from "@utils";
import { useNavigate } from "react-router-dom";
import { useLoadReset } from "@/hooks";

export default function Login() {
  const loadReset = useLoadReset();
  const confirm = useConfirm();
  const navigate = useNavigate();
  const [state, setState] = useAtom(loginState);
  const clickedCheckbox = () => {
    setState((s) => ({ ...s, isPersonal: !s.isPersonal }));
  };
  const resetState = () => {
    setState((s) => ({ ...s, id: "", pw: "", isPersonal: false }));
    loadReset();
  };
  const loginValudate = () => {
    if (!state.id || !state.pw) {
      confirm("아이디와 비밀번호를 입력해주세요.");
      return false;
    }
    const regexHangeul = /[가-힣]/;
    if (regexHangeul.test(state.id) || regexHangeul.test(state.pw)) {
      confirm("한글은 입력할 수 없습니다.");
      return false;
    }
    const regexUnderBar = /[_]/;
    if (regexUnderBar.test(state.id) || regexUnderBar.test(state.pw)) {
      confirm("_는 특수문자로 사용할 수 없습니다.");
      return false;
    }
    return true;
  };
  const login = () => {
    if (!loginValudate()) {
      return;
    }
    Axios.post("/api/login", {
      id: state.id,
      pw: state.pw,
    }).then((res) => {
      if (res.data?.errMsg) {
        confirm(`${res.data.errMsg}\n(${res.data.errCode})`);
        return;
      }
      const personalPc = "personalPc";
      if (state.isPersonal) {
        setCookie(personalPc, state.id + "_" + state.pw, 60 * 60 * 24 * 60);
      } else {
        removeCookie(personalPc);
      }
      setState((s) => ({ ...s, isLogin: true }));
      navigate("/");
    });
  };
  const changePw = (e) => {
    setState((s) => ({ ...s, pw: e.target.value }));
    if (e.key === "Enter") {
      e.target.blur();
      login();
    }
  };
  useEffect(() => {
    return resetState;
  }, []);
  return (
    <div className={styles.mainContainer}>
      <div className={styles.container}>
        <div className={styles.loginTitle}>
          <span className={styles.adminLogin}>관리자 로그인</span>
        </div>
        <div className={styles.idInput}>
          <input
            className={styles.placeholder}
            value={state.id}
            onChange={(e) => {
              setState((s) => ({ ...s, id: e.target.value }));
            }}
            placeholder="아이디"
          />
        </div>
        <div className={styles.passwordInput}>
          <input
            type="password"
            className={styles.placeholder1}
            defaultValue={state.pw}
            onKeyUp={(e) => {
              changePw(e);
            }}
            placeholder="비밀번호"
          />
        </div>
        <div className={styles.emptySpace} />
        <div className={styles.rememberAccount}>
          <div className={styles.descriptionArea}>
            <div className={styles.title}>
              <span className={styles.accountInfo}>계정 정보 기억</span>
            </div>
            <div className={styles.description}>
              <span className={styles.personalPc}>
                개인 PC에서만 사용하십시오
              </span>
            </div>
          </div>
          <div className={styles.checkboxArea} onClick={clickedCheckbox}>
            {!state.isPersonal && <div className={styles.checkbox} />}
            {state.isPersonal && (
              <div className={styles.clickedCheckbox}>
                <img className={styles.imgBox} src={checkIcon} alt="체크" />
              </div>
            )}
          </div>
        </div>
        <div className={styles.buttonFooter}>
          <div className={styles.loginButton}>
            <button className={styles.loginButton2} onClick={login}>
              Log in
            </button>
          </div>
          <Footer />
        </div>
      </div>
    </div>
  );
}
